import { render } from "./Clientes-Component.vue?vue&type=template&id=aa86a5b4&scoped=true"
import script from "./Clientes-Component.vue?vue&type=script&lang=js"
export * from "./Clientes-Component.vue?vue&type=script&lang=js"

import "./Clientes-Component.vue?vue&type=style&index=0&id=aa86a5b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa86a5b4"]])

export default __exports__